module.exports = require("lodash.isdate");